import React, { Component } from "react";
import "antd/dist/antd.css";
import {
    citySearch,
    employementTypeList,
    functionalAreaList,
    salaryList,
    jobRoleList,
} from "../../action/jobs";
import {
    getStorage,
    onChange,
    setIsRequired,
    setOptions,
    validateForm,
} from "../../utils";
import { Typeahead } from "react-bootstrap-typeahead";
import constant from "../../constant";
import Loader from "../Common/Loader";
import { Select } from "antd";

export default class PostAJob extends Component {
    constructor(props) {
        super(props);
        debugger
        const detail = this.props.Data;
        this.state = {
            JOB_TITLE: {
                name: "JOB_TITLE",
                value: detail ? detail.JOB_TITLE : "",
                error: "",
                isRequired: true,
            },
            EMPLOYMENT_TYPE: {
                name: "EMPLOYMENT_TYPE",
                value: detail ? detail.EMPLOYMENT_TYPE_ID : "",
                options: [],
                error: "",
                isRequired: true,
            },
            NO_OF_VACANCIES: {
                name: "NO_OF_VACANCIES",
                value: detail ? detail.NO_OF_VACANCIES : "",
                error: "",
                isRequired: true,
            },

            CTC_MIN: {
                name: "CTC_MIN",
                value: detail ? detail.CTC_MIN : "",
                options: [],
                error: "",
                isRequired: true,
            },
            CTC_MAX: {
                name: "CTC_MAX",
                value: detail ? detail.CTC_MAX : "",
                options: [],
                error: "",
                isRequired: true,
            },
            IS_HIDE_SALARY_FROM_CANDIDATE:
                detail &&
                    detail.IS_HIDE_SALARY_FROM_CANDIDATE &&
                    detail.IS_HIDE_SALARY_FROM_CANDIDATE == "Y"
                    ? true
                    : false,
            IS_WORK_FROM_HOME:
                detail && detail.IS_WORK_FROM_HOME && detail.IS_WORK_FROM_HOME == "Y"
                    ? true
                    : false,
            IS_FIELD_JOB:
                detail && detail.IS_FIELD_JOB && detail.IS_FIELD_JOB == "Y"
                    ? true
                    : false,
            WORK_FROM_HOME_TYPE: {
                name: "WORK_FROM_HOME_TYPE",
                value:
                    detail &&
                        detail.TYPE_OF_WORK_FROM_HOME &&
                        detail.TYPE_OF_WORK_FROM_HOME == "WFHDC"
                        ? "DURING_COVID"
                        : detail &&
                            detail.TYPE_OF_WORK_FROM_HOME &&
                            detail.TYPE_OF_WORK_FROM_HOME == "PRJ"
                            ? "PERMANENT"
                            : ""
                ,
                error: "",
                isRequired: false,
            },


            FUNCTIONAL_AREA_ID: {
                name: "FUNCTIONAL_AREA_ID",
                value: detail ? detail.FUNCTIONAL_AREA_ID : "",
                options: [],
                error: "",
                isRequired: true,
            },

            CITY: {
                name: "CITY",
                value: detail ? detail.CITY_ID : [],
                options: [],
                error: "",
                isRequired: true,
            },

            COMPANY_NAME: {
                name: "COMPANY_NAME",
                value: detail ? detail.COMPANY_NAME : "",
                options: [],
                error: "",
                isRequired: false,
            },
            ADDRESS: {
                name: "ADDRESS",
                value: detail ? detail.ADDRESS : "",
                options: [],
                error: "",
                isRequired: false,
            },
            JOB_ROLE: {
                name: "JOB_ROLE",
                value: detail ? String(detail.ROLE_ID) : "",
                options: [],
                error: "",
                isRequired: true,
            },
            selectedCity: detail ? detail.CITY_ID : [],
        };
    }
    componentDidMount() {
        this.loadlist();
        if (this.props?.Data?.FUNCTIONAL_AREA_ID) {
            const functionalAreaId = this.props.Data.FUNCTIONAL_AREA_ID;
            jobRoleList(functionalAreaId).then((res) => {
                if (res.status) {
                    setOptions(this, "JOB_ROLE", res.result);
                } else {
                    alert(res.error);
                }
            });
        }
    }

    onChange = (e) => {
        const { name, value } = e.target;
        if (name === "FUNCTIONAL_AREA_ID") {
            jobRoleList(value).then((res) => {
                if (res.status) {
                    setOptions(this, "JOB_ROLE", res.result);
                } else {
                    alert(res.error);
                }
            });
        }
        onChange(this, name, value);
    };


    onSubmit = (e) => {
        debugger
        e.preventDefault();
        const {
            IS_WORK_FROM_HOME,
            WORK_FROM_HOME_TYPE,

        } = this.state;
        if (IS_WORK_FROM_HOME) {
            setIsRequired(this, WORK_FROM_HOME_TYPE.name, true);
        }
        if (!IS_WORK_FROM_HOME) {
            setIsRequired(this, WORK_FROM_HOME_TYPE.name, false);
        }

        if (validateForm(this)) {
            const {
                JOB_TITLE,
                EMPLOYMENT_TYPE,
                NO_OF_VACANCIES,
                CTC_MIN,
                CTC_MAX,
                IS_HIDE_SALARY_FROM_CANDIDATE,
                WORK_FROM_HOME_TYPE,
                FUNCTIONAL_AREA_ID,
                CITY,
                JOB_ROLE,
                COMPANY_NAME,
                ADDRESS,
                IS_WORK_FROM_HOME,
                IS_FIELD_JOB
            } = this.state;

            const model = {
                JOB_TITLE: JOB_TITLE.value,
                NO_OF_VACANCIES: NO_OF_VACANCIES.value,
                EMPLOYMENT_TYPE_ID: EMPLOYMENT_TYPE.value,
                IS_FIELD_JOB: IS_FIELD_JOB ? 'Y' : 'N',
                IS_WORK_FROM_HOME: IS_WORK_FROM_HOME ? "Y" : "N",
                IS_WORK_FROM_HOME_DURING_COVID: IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID" ? "Y" : "N",
                TYPE_OF_WORK_FROM_HOME:

                    IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID" ?
                        "WFHDC" : IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "PERMANENT" ? "PRJ" : "",
                CTC_CURRENCY: 1,
                CTC_MIN: CTC_MIN.value,
                CTC_MAX: CTC_MAX.value,
                IS_HIDE_SALARY_FROM_CANDIDATE: IS_HIDE_SALARY_FROM_CANDIDATE,
                FUNCTIONAL_AREA_ID: FUNCTIONAL_AREA_ID.value,
                ROLE_ID: JOB_ROLE.value,
                ADDRESS: ADDRESS.value,
                COMPANY_NAME: COMPANY_NAME.value,
                CITY_ID: CITY.value,
            };
            if (this.props.JOB_ID) {
                model.JOB_ID = this.props.JOB_ID;
            }

            console.log(model)
            this.props.onSubmit(model);
        }
    };


    render() {
        const {
            JOB_TITLE,
            EMPLOYMENT_TYPE,
            NO_OF_VACANCIES,
            CTC_MIN,
            CTC_MAX,
            IS_HIDE_SALARY_FROM_CANDIDATE,
            WORK_FROM_HOME_TYPE,
            FUNCTIONAL_AREA_ID,
            CITY,
            JOB_ROLE,
            COMPANY_NAME,
            ADDRESS,
            IS_WORK_FROM_HOME,
            IS_FIELD_JOB
        } = this.state;


        return (
            <React.Fragment>
                {this.props.showLoader && <Loader />}
                <section className="pricing-area padding-bottom-80px">
                    <div className="container">
                        <div className="row mt-2">
                            <div className="col-lg-12">
                                <div className="billing-form-item mb-0">
                                    <form onSubmit={(e) => { this.onSubmit(e) }}>
                                        <div className="billing-title-wrap">
                                            <h3 className="widget-title pb-0">Job details</h3>

                                            <div className="title-shape margin-top-5px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">

                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">We use this information to find the best candidates for the job.</span>
                                                        <span className="text-danger d-block">*Marked fields are mandatory</span>
                                                    </div>
                                                    <div className="col-md-12 pb-4"><h6 className="font-weight-light">Company you belong to <b>{COMPANY_NAME.value}</b></h6></div>
                                                    {/* <div className="col-lg-12 column-lg-full pt-2">
                                                        <div className="input-box">
                                                            <div className="row">
                                                                <div className="col-lg-12 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Company you're hiring for *
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <input
                                                                                className="form-control"
                                                                                type="text"
                                                                                name={CLIENT_NAME.name}
                                                                                value={CLIENT_NAME.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Enter the client name"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    <div className="col-lg-6 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Job title / Designation{" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <div className="form-group">
                                                                <input
                                                                    className={
                                                                        JOB_TITLE.error.length > 0
                                                                            ? "form-control is-invalid"
                                                                            : "form-control"
                                                                    }
                                                                    type="text"
                                                                    placeholder="Mention the designation or role"
                                                                    name={JOB_TITLE.name}
                                                                    value={JOB_TITLE.value}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-lg-3 column-lg-full pt-2 sq-db5">
                                                        <div className="input-box sq-db5">
                                                            <label className="label-text sq-db5">
                                                                Number of Vacancies{" "}
                                                                <span className="text-danger sq-db5">*</span>
                                                            </label>
                                                            <div className="form-group sq-db5">
                                                                <input
                                                                    className={
                                                                        NO_OF_VACANCIES.error.length > 0
                                                                            ? "form-control is-invalid sq-db5"
                                                                            : "form-control sq-db5"
                                                                    }
                                                                    type="number"
                                                                    min="1"
                                                                    name={NO_OF_VACANCIES.name}
                                                                    value={NO_OF_VACANCIES.value}
                                                                    onChange={this.onChange}
                                                                    placeholder="Vacancies"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="row">

                                                    <div className="col-lg-6 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Functional Area{" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <div className="form-group postjob-select-container">
                                                                <select
                                                                    className={
                                                                        FUNCTIONAL_AREA_ID.error.length > 0
                                                                            ? "form-control is-invalid postjob-select"
                                                                            : "form-control postjob-select"
                                                                    }
                                                                    name={FUNCTIONAL_AREA_ID.name}
                                                                    value={FUNCTIONAL_AREA_ID.value}
                                                                    onChange={this.onChange}
                                                                >
                                                                    <option value="">
                                                                        Choose a functional area for your job
                                                                    </option>
                                                                    {FUNCTIONAL_AREA_ID.options.length > 0 &&
                                                                        FUNCTIONAL_AREA_ID.options.map(
                                                                            (item, index) => {
                                                                                return (
                                                                                    <option
                                                                                        key={index}
                                                                                        value={item.FUNCTIONAL_AREA_ID}
                                                                                    >
                                                                                        {item.FUNCTIONAL_AREA}
                                                                                    </option>
                                                                                );
                                                                            }
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Role<span className="text-danger">*</span>
                                                            </label>
                                                            <div className="form-group postjob-select-container">
                                                                <Select
                                                                    className={
                                                                        JOB_ROLE.error.length > 0
                                                                            ? "is-invalid"
                                                                            : ""
                                                                    }
                                                                    placeholder="Select Job Role"
                                                                    onChange={(e) => {
                                                                        debugger
                                                                        const available = JOB_ROLE.options.find(item => item.ROLE_NAME.toLowerCase() === (e.length > 0 ? e[e.length - 1].toLowerCase() : ""))
                                                                        if (available) {
                                                                            onChange(this, JOB_ROLE.name, available.ROLE_ID)
                                                                        }
                                                                        else {
                                                                            onChange(this, JOB_ROLE.name, e.length > 0 ? e[e.length - 1] : "")
                                                                        }
                                                                    }}
                                                                    mode="tags"
                                                                    value={JOB_ROLE.value.length > 0 ? JOB_ROLE.value : undefined}
                                                                    notFoundContent=""
                                                                >
                                                                    {JOB_ROLE.options.length > 0 &&
                                                                        JOB_ROLE.options.map((item, index) => {
                                                                            return (
                                                                                <Select.Option key={index} value={item.ROLE_ID.toString()}>
                                                                                    {item.ROLE_NAME}
                                                                                </Select.Option>
                                                                            );
                                                                        })}
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Type of Job{" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <div className="form-group postjob-select-container">
                                                                <select
                                                                    className={
                                                                        EMPLOYMENT_TYPE.error.length > 0
                                                                            ? "form-control is-invalid postjob-select"
                                                                            : "form-control postjob-select"
                                                                    }
                                                                    name={EMPLOYMENT_TYPE.name}
                                                                    value={EMPLOYMENT_TYPE.value}
                                                                    onChange={this.onChange}
                                                                >
                                                                    <option value="">Select Job Type</option>
                                                                    {EMPLOYMENT_TYPE.options.length > 0 &&
                                                                        EMPLOYMENT_TYPE.options.map(
                                                                            (item, index) => {
                                                                                return (
                                                                                    <option
                                                                                        key={index}
                                                                                        value={item.EMPLOYMENT_TYPE_ID}
                                                                                    >
                                                                                        {item.EMPLOYMENT_TYPE}
                                                                                    </option>
                                                                                );
                                                                            }
                                                                        )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="billing-title-wrap">
                                            <h3 className="widget-title pb-0">Location</h3>

                                            <div className="title-shape margin-top-5px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">

                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">Let candidates know where they will be working from.                                                        .</span>
                                                    </div>

                                                    <div className="col-lg-12 column-lg-full">
                                                        <div className="wfh-input-box">
                                                            Work location type *
                                                        </div>

                                                        <div className="wfhduring">
                                                            <ul>
                                                                <li>
                                                                    <input
                                                                        type="radio"
                                                                        checked={!IS_WORK_FROM_HOME && !IS_FIELD_JOB}
                                                                        onClick={() => this.setState({
                                                                            IS_WORK_FROM_HOME: false,
                                                                            IS_FIELD_JOB: false
                                                                        })}
                                                                    />
                                                                    <div className="wfhheading">
                                                                        Work from Office
                                                                        <p>Candidate will work from the office</p>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <input
                                                                        type="radio"
                                                                        checked={IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "DURING_COVID"}
                                                                        onClick={() => {
                                                                            onChange(this, WORK_FROM_HOME_TYPE.name, "DURING_COVID");
                                                                            this.setState({
                                                                                IS_WORK_FROM_HOME: true,
                                                                            });
                                                                        }}
                                                                    />
                                                                    <div className="wfhheading">
                                                                        Temporary Work From Home (Hybrid)
                                                                        <p>Candidate will work from home or office based on company requirement.</p>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <input
                                                                        type="radio"
                                                                        checked={IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === "PERMANENT"}
                                                                        onClick={() => {
                                                                            onChange(this, WORK_FROM_HOME_TYPE.name, "PERMANENT");
                                                                            this.setState({
                                                                                IS_WORK_FROM_HOME: true,
                                                                            });
                                                                        }}
                                                                    />
                                                                    <div className="wfhheading">
                                                                        Permanent Remote
                                                                        <p>Candidate can permanently work from home</p>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <input
                                                                        type="radio"
                                                                        checked={IS_FIELD_JOB && !IS_WORK_FROM_HOME}
                                                                        onClick={() => this.setState({
                                                                            IS_FIELD_JOB: !IS_FIELD_JOB,
                                                                            IS_WORK_FROM_HOME: false
                                                                        })}
                                                                    />
                                                                    <div className="wfhheading">
                                                                        Field Job
                                                                        <p>Candidate will need to be on the field for their job</p>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 column-lg-full pt-3">

                                                        <div className="input-box sq-bd1">
                                                            <label className="label-text sq-bd1">
                                                                Location{" "}
                                                                <span className="text-danger font-size-16 sq-bd1">
                                                                    *
                                                                </span>
                                                            </label>
                                                            {CITY.value.map((item, index) => {
                                                                return (
                                                                    <span className="locationbox sq-bd1">
                                                                        {" "}
                                                                        {item.CITY}{" "}
                                                                        <i
                                                                            onClick={() =>
                                                                                this.deleteLocation(item.CITY)
                                                                            }
                                                                            className="fa fa-close sq-bd1"
                                                                        ></i>
                                                                    </span>
                                                                );
                                                            })}
                                                            <div className="form-group sq-bd1">
                                                                <Typeahead
                                                                    id="ta-location-ids"
                                                                    allowNew={false}
                                                                    labelKey={(option) => `${option.CITY}`}
                                                                    selected={CITY.value}
                                                                    multiple={true}
                                                                    options={CITY.options}
                                                                    onChange={(e) => {
                                                                        this.locationOnChange(e);
                                                                    }}
                                                                    onInputChange={(e) => {
                                                                        this.onKeywordPress(e, "LOCATION");
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.code === 'Enter') {
                                                                            let arg = { ...CITY };
                                                                            arg = arg.value;
                                                                            let available = CITY.options.find(item => item.CITY.toLowerCase() === e.target.value.toLowerCase())
                                                                            let existed = arg.find(item => item.CITY.toLowerCase() === e.target.value.toLowerCase())
                                                                            if (available && !existed) {
                                                                                this.locationOnChange([...arg, available]);

                                                                            }
                                                                            else if (!available && !existed) {
                                                                            }
                                                                        }
                                                                    }}
                                                                    placeholder="Search and add new locations"
                                                                    emptyLabel
                                                                    className={
                                                                        CITY.error.length > 0 ? "errorMsg" : ""
                                                                    }
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {((IS_WORK_FROM_HOME && WORK_FROM_HOME_TYPE.value === 'DURING_COVID') || IS_FIELD_JOB || !IS_WORK_FROM_HOME) && (
                                                        <div className="col-lg-12 pt-2">
                                                            <div className="input-box">
                                                                <label className="label-text">
                                                                    Office address / landmark{' '}
                                                                    <span className="text-danger font-size-16 sq-bd1">
                                                                        *
                                                                    </span>
                                                                </label>
                                                                <div className="form-group mb-0">
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name={ADDRESS.name}
                                                                        value={ADDRESS.value}
                                                                        onChange={this.onChange}
                                                                        placeholder="Office address / landmark"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>

                                            </div>
                                        </div>

                                        <hr />
                                        <div className="billing-title-wrap">
                                            <h3 className="widget-title pb-0">Compensation</h3>

                                            <div className="title-shape margin-top-5px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">

                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">Job postings with right salary will help you find the right candidates.</span>
                                                    </div>


                                                    <div className="col-lg-12 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text pb-0">
                                                                Annual Salary Range (in Lakhs){" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <div className="row">
                                                                <div className="col-lg-2">
                                                                    <div className="form-group postjob-select-container">
                                                                        <select className="postjob-select">
                                                                            <option value>Rs.</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group postjob-select-container">
                                                                        <select
                                                                            className={
                                                                                CTC_MIN.error.length > 0
                                                                                    ? "form-control is-invalid postjob-select"
                                                                                    : "form-control postjob-select"
                                                                            }
                                                                            name={CTC_MIN.name}
                                                                            value={CTC_MIN.value}
                                                                            onChange={this.onChange}
                                                                        >
                                                                            <option value="">
                                                                                Min Annual Salary
                                                                            </option>
                                                                            {CTC_MIN.options.length > 0 &&
                                                                                CTC_MIN.options.map(
                                                                                    (item, index) => {
                                                                                        return (
                                                                                            <option value={item.SALARY}>
                                                                                                {item.SALARY_DETAILS}
                                                                                            </option>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group postjob-select-container">
                                                                        <select
                                                                            className={
                                                                                CTC_MAX.error.length > 0
                                                                                    ? "form-control is-invalid postjob-select"
                                                                                    : "form-control postjob-select"
                                                                            }
                                                                            name={CTC_MAX.name}
                                                                            value={CTC_MAX.value}
                                                                            onChange={this.onChange}
                                                                        >
                                                                            <option value="">
                                                                                Max Annual Salary
                                                                            </option>
                                                                            {CTC_MAX.options.length > 0 &&
                                                                                CTC_MAX.options.map(
                                                                                    (item, index) => {
                                                                                        if (
                                                                                            Number(item.SALARY) >
                                                                                            Number(CTC_MIN.value)
                                                                                        )
                                                                                            return (
                                                                                                <option value={item.SALARY}>
                                                                                                    {item.SALARY_DETAILS}
                                                                                                </option>
                                                                                            );
                                                                                    }
                                                                                )}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full">
                                                        <div class="wfh-input-box">
                                                        </div>
                                                        <div class="wfh-input-box">
                                                            <input
                                                                type="checkbox"
                                                                checked={IS_HIDE_SALARY_FROM_CANDIDATE}
                                                                onClick={() =>
                                                                    this.setState({
                                                                        IS_HIDE_SALARY_FROM_CANDIDATE:
                                                                            !IS_HIDE_SALARY_FROM_CANDIDATE,
                                                                    })
                                                                }
                                                            />
                                                            Hide salary details from candidates
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-12 text-right">
                                                    <div className="btn-box">
                                                        <button
                                                            type="submit"
                                                            className="theme-btn border-0"
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>

                        </div>

                    </div>
                </section >



            </React.Fragment >
        );
    }
    locationOnChange = (e) => {
        onChange(this, this.state.CITY.name, e);
        // const CITY_ID = e.map((item) => {
        //     return item.CITY_ID;
        // });
        // getLocalities({ CITY_ID: CITY_ID }).then((res) => {
        //     if (res.status) {
        //         setOptions(this, this.state.LOCALITIES.name, res.result);
        //     } else {
        //         alert(res.error);
        //     }
        // });
    };
    deleteLocation = (input) => {
        const { CITY } = this.state;
        let arr = CITY.value.filter((item) => {
            if (item.CITY != input) {
                return item;
            }
        });
        // const CITY_ID = arr.map((item) => {
        //     return item.CITY_ID;
        // });
        // getLocalities({ CITY_ID: CITY_ID }).then((res) => {
        //     if (res.status) {
        //         setOptions(this, this.state.LOCALITIES.name, res.result);
        //     } else {
        //         alert(res.error);
        //     }
        // });

        onChange(this, "CITY", arr);
    };


    onKeywordPress = (value, TYPE) => {
        if (TYPE === "LOCATION") {
            citySearch(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.CITY.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        }
    };





    loadlist = () => {
        const ud = getStorage(constant.keys.userDetails);
        onChange(this, this.state.COMPANY_NAME.name, ud.COMPANY_NAME);
        employementTypeList()
            .then((res) => {
                if (res.status) {
                    setOptions(this, this.state.EMPLOYMENT_TYPE.name, res.result);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });

        salaryList()
            .then((res) => {
                if (res.status) {
                    setOptions(this, this.state.CTC_MIN.name, res.result);
                    setOptions(this, this.state.CTC_MAX.name, res.result);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });


        functionalAreaList()
            .then((res) => {
                if (res.status) {
                    setOptions(this, this.state.FUNCTIONAL_AREA_ID.name, res.result);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });


    };
}
